import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const Reset = (props: SvgProps) => (
  <Svg width='22' height='19' viewBox='0 0 22 19' fill='none' {...props}>
    <Path
      d='M21 1V7.66667H16'
      stroke='#5FECFD'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M1 16V11H6'
      stroke='#5FECFD'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M3.27273 6.55254C3.73379 5.22569 4.51739 4.0394 5.55042 3.10437C6.58345 2.16933 7.83224 1.51603 9.18026 1.20542C10.5283 0.894814 11.9316 0.937027 13.2593 1.32811C14.5869 1.71919 15.7957 2.4464 16.7727 3.44189L21 7.47833M1 11.1815L5.21818 15.2179C6.19508 16.2156 7.40445 16.9447 8.73323 17.337C10.062 17.7294 11.4668 17.7722 12.8162 17.4615C14.1656 17.1508 15.4157 16.4967 16.4494 15.5603C17.4832 14.6239 18.2669 13.4359 18.7273 12.1073'
      stroke='#5FECFD'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
)
